// extracted by mini-css-extract-plugin
export default {"landscapeWrapper":"LandscapeProjectsAddBasicInformationOrganism_landscapeWrapper__r9UJa","divWrapper":"LandscapeProjectsAddBasicInformationOrganism_divWrapper__KNSEw"};